{
  "enums": {
    "standard_category_type": {
      "food_and_beverage": "Food & Beverage",
      "cleaning": "Cleaning",
      "operations": "Operations",
      "it_hardware": "IT Hardware",
      "it_software": "IT Software",
      "maintenance": "Maintenance",
      "furniture": "Furniture",
      "packaging": "Packaging",
      "uniforms": "Uniforms",
      "marketing_and_print": "Marketing & Print",
      "medical_and_safety": "Medical & Safety",
      "professional_services": "Professional Services",
      "utilities": "Utilities",
      "logistics": "Logistics",
      "other": "Other"
    }
  },
  "category": {
    "standardTypeField": "Standard procurement type",
    "standardTypeHint": "The standard type this category belongs to. Approval rules that route requests by standard type use the type set on this category itself, so they keep working when you rename it.",
    "standardTypeNone": "Not mapped",
    "standardTypeChoose": "Choose a standard type",
    "standardTypeRequired": "Mapping required",
    "standardTypeRequiredError": "Choose a standard procurement type. A category can be active only when it has one.",
    "standardTypeLegacy": "This category is active without a standard type. Choose one to save your changes."
  }
}
